/**
 * Componente principal para la verificación de eventos.
 *
 * Este componente proporciona la estructura de layout para la página
 * de verificación de eventos de usuarios por documento de identidad.
 *
 * @author Victor Manuel Calle Londoño <victor.calle@iudigital.edu.co>
 * @date 2025-10-22
 * @updated 2025-10-22
 * @updatedBy Victor Manuel Calle Londoño <victor.calle@iudigital.edu.co>
 */

import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import VerifyEventsController from "./controllers/VerifyEventsController";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";

/**
 * Componente de página para verificación de eventos.
 *
 * @returns {JSX.Element} Página completa con layout y controlador de verificación.
 */
function VerifyEvents() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h3" color="white">
                  Verificar eventos
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <div style={{ marginTop: "64px", textAlign: "center" }}>
                  <VerifyEventsController />
                </div>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default VerifyEvents;
